// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/portal/gaicon.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".footer{background:#111;padding:23px 0 57px 0}.footer .wrap-lg{width:1226px;margin:0 auto}.footer a,.footer span{font-size:14px;color:#464646}.footer a{padding-left:34px}.footer a:hover,.footer a:hover span{color:#ca4300}.footer a i{display:inline-block;width:13px;height:13px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:cover}", ""]);
// Exports
module.exports = exports;
